export function getPointerClientPosition(event) {
  if (event instanceof MouseEvent) {
    return [event.clientX, event.clientY]
  } else if (
    window.TouchEvent != null &&
    event instanceof TouchEvent &&
    event.touches.length > 0
  ) {
    return [event.touches[0].clientX, event.touches[0].clientY]
  } else {
    return [0, 0]
  }
}
